import ChildrenPropsContext from '@xanadu/ui-shared/contexts/ChildrenPropsContext';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { getClientOrigin } from '../utils';

const PageWrapper = ({
  Component,
  componentProps,
  configProps,
  brand,
  site,
  seo,
}) => {
  const {
    featuresFlags: {
      crawlingEnabled,
    } = {},
  } = configProps;

  const origin = getClientOrigin(brand, site);

  const computedCrawlingEnabled = crawlingEnabled && window.location.hostname === origin;

  useEffect(() => {
    let meta = document.querySelector('meta[name="robots"]');
    const importedTagExisted = !!meta;

    if (computedCrawlingEnabled) {
      if (!seo) {
        if (!meta) {
          meta = document.createElement('meta');
          meta.name = 'robots';
          document.head.appendChild(meta);
        }

        meta.setAttribute('content', 'noindex, follow');
      }
    }


    return () => {
      if (computedCrawlingEnabled) {
        if (!seo && meta) {
          if (importedTagExisted) {
            meta.removeAttribute('content');
          } else {
            meta.remove();
          }
        }
      }
    };
  }, [seo, computedCrawlingEnabled]);

  useEffect(() => {
    const existingMetaRobots = document.querySelector('meta[name="robots"]');


    if (!computedCrawlingEnabled && !existingMetaRobots) {
      const meta = document.createElement('meta');
      meta.name = 'robots';
      document.head.appendChild(meta);
      meta.setAttribute('content', 'noindex, nofollow');
    }
  }, [computedCrawlingEnabled]);

  return (
    <ChildrenPropsContext.Provider
      value={{
        ...configProps,
        ...(componentProps ? { childrenProps: componentProps.childrenProps } : {})
      }}
    >
      <Component {...componentProps} />
    </ChildrenPropsContext.Provider>
  );
};

PageWrapper.propTypes = {
  Component: PropTypes.elementType.isRequired,
  brand: PropTypes.string.isRequired,
  site: PropTypes.string.isRequired,
  componentProps: PropTypes.instanceOf(Object),
  configProps: PropTypes.instanceOf(Object),
  seo: PropTypes.bool,
};

export default PageWrapper;
